export default {
    data() {
        return {
            pending: false,
            currentPage: 1,
            perPage: null,
            totalRows: 0,
            search: null,
            params: this.$route.query,
            meta: {}
        };
    },
    computed: {
        showPagination() {
            return (
                this.totalRows > this.perPage ||
                (this.totalRows > 0 && this.currentPage > 1)
            );
        },

        showNoResult() {
          if (this.pending) {
              return false;
          }

          return !this.items.length;
        },

        hasItems() {
            return this.items.length > 0;
        },

    },
    methods: {
        fetchData(ctx) {
           return this.axios
                .get(ctx.apiUrl, {
                    params: {
                        page: ctx.currentPage,
                        perPage: ctx.perPage,
                        search: ctx.filter,
                        ...this.params
                    }
                })
                .then(({data}) => {
                    this.meta = data.meta || {};
                    this.perPage = data.per_page || this.meta.per_page
                    this.totalRows = data.total || this.meta.total

                    return data.data || data || [];
                })
                .catch(e => {
                    if (!e.response) {
                        throw e;
                    }
                    this.setData({})
                });
        },

        handleDelete(apiUrl) {
            const _this = this;


            this.$bvModal.msgBoxConfirm(this.$t('Are you sure to delete this item?'), {
                title: this.$t('Are you sure?'),
                okVariant: 'danger',
                okTitle: this.$t('Yes'),
                cancelTitle: this.$t('No'),
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (!value) {
                    return;
                }

                this.axios
                    .delete(apiUrl)
                    .catch(e => e.response || throw e)
                    .then(function() {
                        if (_this.$refs.table) {
                            _this.$refs.table.refresh();
                        }
                    })
            })
        }
    },

    watch: {
        params: {
            handler() {
                if (this.$refs && this.$refs.table) {
                    this.$refs.table.refresh();
                }
            },
            deep: true
        }
    }
};
